export default "__VITE_ASSET__D3LdyHMh__"